module.exports = __webpack_public_path__ + "img/about.a69348e9.webp";